import React from 'react';

const MDeliverySequence = ({ deliveries }) => {

    const isCanceled = (customer_id, sequence) => {
        const canceled = deliveries.filter(delivery => {
            const invoices = delivery.customers.filter(customer => {
                return (customer.customer_id === customer_id) && (customer.status === 'canceled')
            });

            return !!invoices.length;
        });

        return !!canceled.length;
    }

    const getStatusClassName = (delivery, planned_sequence, sequence) => {
        let status = 'pending';
        const is_canceled = isCanceled(delivery.customer_id, sequence);

        if (is_canceled) {
            status = 'canceled';
        } else if (!sequence) {
            status = '';
        } else if (planned_sequence !== sequence) {
            status = 'out_of_plan';
        } else if (planned_sequence === sequence) {
            status = 'delivered';
        }

        switch(status) {
            case 'out_of_plan':
                return 'bg-blue c-white';

            case 'canceled':
                return 'bg-red c-white';

            case 'delivered':
                return 'bg-green c-white';

            default:
                return '';
        }
    }

    let costumers_sequence = {};
    let costumers = [];

    deliveries.forEach(delivery => {
        costumers_sequence[delivery.customer_id] = delivery.sequence;
    });

    for(const i in costumers_sequence) {
        if (costumers_sequence[i]) {
            costumers[costumers_sequence[i]] = i;;
        }
    }

    const customers_sequence_ordered = Object.values(costumers);
    let customers_sequence_inverted = {};

    customers_sequence_ordered.forEach((customer_id, index) => {
        customers_sequence_inverted[customer_id] = index + 1;
    });

    let items = deliveries.map((delivery, index) => {
        const sequence = customers_sequence_inverted[delivery.customer_id];
        const planned_sequence = (index + 1);

        return (
            <div className="sequence-item" key={index}>
                <div className="sequence-number">{planned_sequence}</div>
                <div className={`sequence-box ${getStatusClassName(delivery, planned_sequence, sequence)}`}>{sequence}</div>
            </div>
        )
    });

    return (
        <div className="md-sequence-container">
            <h3>Sequência de entregas</h3>

            <div className="md-sequence">
                {items}
            </div>
        </div>
    );

}

MDeliverySequence.defaultProps = {
    customers: []
};

export default MDeliverySequence;



// WEBPACK FOOTER //
// ./src/components/MDeliverySequence.js